// extracted by mini-css-extract-plugin
export default {"root":"styles_root__xvR2N","content":"styles_content__2BvsZ","contentShift":"styles_contentShift__MvnP4","fakeToolbar":"styles_fakeToolbar__AKLfB"};